import { createTheme, createVariant } from '@clds/component-theme';
const asTypography = (size, type) => ({
    type,
    size,
});
export const avatarTheme = createTheme({
    sm: {
        width: '24px',
        typography: asTypography('xs', 'regular'),
        iconSize: 'sm',
    },
    md: {
        width: '28px',
        typography: asTypography('xs', 'regular'),
        iconSize: 'sm',
    },
    lg: {
        width: '32px',
        typography: asTypography('sm', 'regular'),
        iconSize: 'md',
    },
});
export const avatarSizeVariant = createVariant((props) => avatarTheme[props.size]);
//# sourceMappingURL=theme.js.map